export const calculateAlertRange = (
    relative: boolean,
    relativeRange: number,
    absoluteRange: number,
    targetTime: number
) => relative ? Math.floor(targetTime / relativeRange) : absoluteRange;
